import React from 'react';
import { IPaymentProps } from '..';
import styles from '../index.module.scss';
import { KV } from './kv';

function IOSPlatform({ data }: IPaymentProps) {
  const payload = data?.data as unknown;

  return (
    <div className="kv-list ios-platform">
      <div className="kv-cols">
        <div className="kv-key kv-row">Data:</div>
        <div className={styles.mb25}>
          <KV data={payload} />
        </div>
      </div>
    </div>
  );
}

export default IOSPlatform;
